/**
 * Created by suhel on 4/26/17.
 */
import React, { Component, PropTypes } from 'react';
import { inject, observer } from 'mobx-react';
import { observable, toJS, action } from 'mobx';
// import HierTable from '../HierTable';
import * as api from '../../actions/api';
import { token } from "../../libs/localStorage";
import Spinner from "../Spinner";
import { autorun } from "mobx/lib/mobx";
import Form, { FormBody } from "../Form";

@inject('parameterTypeStore', 'parameterPermissionStore', 'rolePermissionStore', 'userStore')
@observer
class ParameterPermissionList extends Component {

  static contextTypes = {
    router: PropTypes.object.isRequired,
    notify: PropTypes.object.isRequired,
  };

  columns = [
    // { key: 'id', label: 'ID' },
    { key: 'name', label: 'Name', colClassName: 'level-2-indent-left' },
    { key: 'selected', label: 'Permission Grant' },
  ];

  @observable data = [];
  @observable checkAll = false;
  @observable forCheckBox = [];
  @observable searchFilter = '';
  @observable savedPermissions = [];
  @observable fetchingPermission = false;

  componentWillMount() {
    const { parameterTypeStore, params: { id } } = this.props;
    if (parameterTypeStore.items.length === 0) parameterTypeStore.fetchItems();
    this.dispose = autorun(() => {
      if (parameterTypeStore.items.length > 0) {
        this.setCheckboxSelected(parameterTypeStore.items);
        this.flattenTableData(parameterTypeStore.items);
        this.makeRequest(id);
        if (typeof this.dispose === 'function') this.dispose();
      }
    });
  }

  componentWillReceiveProps(nextProps) {
    if (+nextProps.params.id !== +this.props.params.id) {
      this.makeRequest(nextProps.params.id);
    }
  }

  @action onChangeSearchText = e => {
    this.checkAll = false;
    this.searchFilter = e.target.value.toLowerCase();
  }

  @action setCheckboxSelected = (parameterTypes) => {
    this.forCheckBox = [];
    parameterTypes.map(parameterType => {
      this.forCheckBox.push({
        level: 1,
        id: parameterType.id,
        parameterTypeId: parameterType.id,
        selected: false,
        expanded: false
      });
      if (!!parameterType.parameters) parameterType.parameters.map(parameter => {
        this.forCheckBox.push({
          level: 2,
          id: parameter.id,
          parameterId: parameter.id,
          selected: false,
          parentId: parameterType.id
        })
      })
    })
  };

  makeRequest = (id) => {
    this.fetchingPermission = true;
    api.userPermission.parameter.fetchById(id).then(res => {
      this.savedPermissions = res;
      this.forCheckBox.map(fcb => {
        fcb.selected = false;
      });

      res.length && res.map(perm => {
        let parameter = this.forCheckBox.find(cb => cb.parameterId == perm.parameter_id)
        if (parameter) parameter.selected = true;
      });

      let parentRows = this.forCheckBox.filter(cb => cb.level == 1);
      parentRows.map((cbParent, i) => {
        let allChildChecked = true;
        let cbChilds = this.forCheckBox.filter(cbChild => cbChild.parentId && cbChild.parentId == cbParent.id);
        if (cbChilds.length > 0) {
          cbChilds.map(cbChild => {
            if (allChildChecked && !cbChild.selected) allChildChecked = cbChild.selected;
          });
        } else {
          allChildChecked = false;
        }
        cbParent.selected = allChildChecked;
      });
      this.fetchingPermission = false;
    }).catch(console.error);
  };

  @action onChangeCheck(index) {
    let selectedItem = this.data[index];
    this.forCheckBox[index].selected = !this.forCheckBox[index].selected;

    if (selectedItem.level == 1) {
      for (let i = index + 1; i < this.data.length; i++) {
        if (this.data[i].level == 1) {
          break;
        }
        this.forCheckBox[i].selected = this.forCheckBox[index].selected;
      }
    }
  }

  @action onCheckAll = (e) => {
    this.checkAll = e.target.checked;

    const filteredStations = this.data.filter(item => item.level === 2 && (item.name.toLowerCase().includes(this.searchFilter) || item.code.toLowerCase().includes(this.searchFilter)));

    if (this.searchFilter === '') {
      this.forCheckBox.forEach(item => {
        item.selected = e.target.checked;
      });
    } else {
      this.forCheckBox.filter(i => filteredStations.find(fi => fi.id === i.id)).forEach(item => {
        item.selected = e.target.checked;
      });
    }
  };

  flattenTableData = (parameterTypes) => {
    this.data = [];
    parameterTypes.map(parameterType => {
      this.data.push({
        type: 'FOLDER',
        level: 1,
        key: this.data.length,
        id: parameterType.id,
        name: parameterType.name,
        selected: <input type="checkbox" onChange={this.onChangeCheck.bind(this, this.data.length)}
          value={this.forCheckBox.filter(cbitem => cbitem.parameterTypeId == parameterType.id)[0].selected}
          checked={this.forCheckBox.filter(cbitem => cbitem.parameterTypeId == parameterType.id)[0].selected} />,
        data: {
          id: parameterType.id,
          name: parameterType.name,
          selected: <input type="checkbox" onChange={this.onChangeCheck.bind(this, this.data.length)}
            value={this.forCheckBox.filter(cbitem => cbitem.parameterTypeId == parameterType.id)[0].selected}
            checked={this.forCheckBox.filter(cbitem => cbitem.parameterTypeId == parameterType.id)[0].selected} />
        }
      });
      if (!!parameterType.parameters) parameterType.parameters.map(parameter => {
        this.data.push({
          type: 'STATION',
          level: 2,
          key: this.data.length,
          id: parameter.id,
          code: parameter.code,
          name: parameter.name,
          selected: <input type="checkbox" onChange={this.onChangeCheck.bind(this, this.data.length)}
            value={this.forCheckBox.filter(cbitem => cbitem.parameterId == parameter.id)[0].selected}
            checked={this.forCheckBox.filter(cbitem => cbitem.parameterId == parameter.id)[0].selected} />,
          parent_id: parameterType.id,
          data: {
            id: parameter.id,
            code: parameter.code,
            name: parameter.name,
            selected: <input type="checkbox" onChange={this.onChangeCheck.bind(this, this.data.length)}
              value={this.forCheckBox.filter(cbitem => cbitem.parameterId == parameter.id)[0].selected}
              checked={this.forCheckBox.filter(cbitem => cbitem.parameterId == parameter.id)[0].selected} />
          }
        })
      })
    });
  };

  handleSaveUserStationPermission = () => {
    const { params: { id }, parameterPermissionStore } = this.props;
    const { notify, router } = this.context;

    let json = [];
    this.forCheckBox.map(cb => {
      if (cb.level == 2 && cb.selected) {
        json.push({
          user_id: id,
          parameter_id: cb.parameterId
        });
      }
    });
    api.userPermission.parameter.create({
      user_id: id,
      permissions: json
    }).then(res => {
      if (+id === +token.getDecoded().id) parameterPermissionStore.items = json;
      notify.success(res);
      router.push('/user');
    }).catch(notify.error);
  };

  render = () => {
    const { params: { id }, rolePermissionStore, parameterTypeStore } = this.props;
    let modifyPermission = rolePermissionStore.validateRole('modify permission');
    return (
      <div style={{ height: '70vh', overflowY: 'scroll', width: '70vw' }}>
        {(parameterTypeStore.isLoading || rolePermissionStore.isLoading || this.fetchingPermission) ? <Spinner /> :
          <div>
            <Form>
              <FormBody>
                <div className='formInput'><input placeholder="Search" onChange={this.onChangeSearchText}
                  style={{ margin: 10 }} /></div>
              </FormBody>
            </Form>
            <div className="HierTable">
              <table>
                <thead>
                  <tr>
                    {this.searchFilter === '' && <th>{''}</th>}
                    <th>Name</th>
                    <th>
                      Permission Grant
                      <input type="checkbox" style={{ marginLeft: 10 }}
                        checked={this.checkAll}
                        disabled={!modifyPermission}
                        onChange={this.onCheckAll}
                      />
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {this.searchFilter === '' ? this.data.map((cb, index) => {
                    let prevExpanded, caretDown = false, caretRight = false, checked = false, display = +cb.level === 1;

                    let parameterTypeCBItem = this.forCheckBox.find(x => +x.parameterTypeId === +cb.id),
                      parentCBItem = this.forCheckBox.find(fcb => +fcb.parameterTypeId === +cb.parent_id),
                      parameterCBItem = this.forCheckBox.find(fcb => +fcb.parameterId === +cb.id);

                    if (+cb.level === 1) {
                      prevExpanded = parameterTypeCBItem.expanded;
                      caretDown = +cb.level === 1 && prevExpanded;
                      caretRight = +cb.level === 1 && !prevExpanded;
                      checked = parameterTypeCBItem.selected;
                    } else if (+cb.level === 2) {
                      checked = parameterCBItem.selected;
                      display = parentCBItem.expanded;
                    }
                    const onClickExpandCollapse = () => {
                      if (+cb.level === 1) parameterTypeCBItem.expanded = !prevExpanded;
                    };

                    if (!display) {
                      return;
                    }

                    return (
                      <tr className={`level-${cb.level}`} key={cb.key}>
                        <td className="caret" onClick={onClickExpandCollapse}>
                          {caretDown && <i className="fa fa-caret-down" aria-hidden="true" />}
                          {caretRight && <i className="fa fa-caret-right" aria-hidden="true" />}
                        </td>
                        <td onClick={onClickExpandCollapse}>{cb.name || cb.id}</td>
                        <td><input type="checkbox"
                          disabled={!modifyPermission}
                          onChange={this.onChangeCheck.bind(this, index)}
                          value={checked}
                          checked={checked} /></td>
                      </tr>
                    );

                  }) : this.data.filter(item => item.level === 2 && (item.name.toLowerCase().includes(this.searchFilter) || item.code.toLowerCase().includes(this.searchFilter))).map(cb => {
                    let parameterCBItem = this.forCheckBox.find(fcb => +fcb.parameterId === +cb.id);

                    const checked = parameterCBItem.selected;

                    return (
                      <tr className={`level-${cb.level}`} key={cb.key}>
                        <td>{cb.name || cb.id}</td>
                        <td><input type="checkbox"
                          disabled={!modifyPermission}
                          onChange={this.onChangeCheck.bind(this, this.data.indexOf(cb))}
                          value={checked}
                          checked={checked} /></td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              {modifyPermission &&
                <button className="button" onClick={this.handleSaveUserStationPermission}>Save</button>}
            </div>
          </div>}
      </div>
    )
  };

}

export default ParameterPermissionList;


// WEBPACK FOOTER //
// ./src/components/Permission/ParameterPermissionList.js